// src/features/executive/account/hooks/use-balance.ts
import { useExecutiveQuery } from 'features/executive/shared/hooks/use-executive-query'
import AccountApi from 'api/executive/account.api'
import type {
  BalanceResponse,
  GetAccountFlowParams,
} from 'api/executive/executive.types'

export function useBalance() {
  return useExecutiveQuery<GetAccountFlowParams, BalanceResponse>(
    'account.balance',
    AccountApi.getBalance,
    (f) => {
      if (!f.dateRange?.start || !f.dateRange?.end) return null
      return {
        dateFrom: f.dateRange.start,
        dateTo: f.dateRange.end,
        branchId: f.branchId ?? undefined,
        paymentType: f.paymentType ?? undefined,
      }
    }
  )
}
